<template>
<div class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp">
  <div class="ga-form-title">
    <h2 class="ga-title-text">{{'profile.edit.label.title' | label}}</h2>
  </div>
  <div class="mdl-card__supporting-text fill">
    <slot></slot>
    <validator name="passwordValidator">
      <form novalidate>
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.edit.label.password.old' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="password" id="old" v-model="password['old']" initial="off"
              v-validate:old="['password', 'required']">
              <!--<label class="mdl-textfield__label" for="old">{{'profile.edit.label.password.old' | label}}</label>-->
              <span class="validation-error mdl-textfield__error" v-if="$passwordValidator.old.required">
                {{'profile.edit.label.password.old.validation' | label}}</span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.edit.label.password.new' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="password" id="new" v-model="password['new']" initial="off"
              v-validate:new="['password', 'required']">
              <!--<label class="mdl-textfield__label" for="new">{{'profile.edit.label.password.new' | label}}</label>-->
              <span class="validation-error mdl-textfield__error" v-if="$passwordValidator.new.required">
                {{'profile.edit.label.password.new.validation' | label}}</span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'profile.edit.label.password.new2' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="password" id="new2" v-model="password['new2']" initial="off"
              v-validate:new2="['password', 'required']">
              <!--<label class="mdl-textfield__label" for="new2">{{'profile.edit.label.password.new2' | label}}</label>-->
              <span class="validation-error mdl-textfield__error" v-if="$passwordValidator.new2.required">
                {{'profile.edit.label.password.new2.validation' | label}}</span>
              <span class="validation-error mdl-textfield__error" v-if="$passwordValidator.new2.notmatch">
                {{'profile.edit.label.password.new2.notmatch' | label}}</span>
            </div>
          </div>
        </div>
      </form>
    </validator>
  </div>
  <div class="mdl-card__actions">
    <div class="card-grid mdl-grid">
      <div class="mdl-cell mdl-cell--6-col">
        <div class="link" v-on:click="$dispatch('back')")>{{'profile.edit.button.back' | label}}</div>
      </div>
      <div class="mdl-cell mdl-cell--6-col">
        <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
          v-on:click="submit">
          {{'profile.edit.button.submit' | label}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
module.exports = {
  methods: {
    submit: function () {
      var self = this
      this.$validate(true, function () {
        if (self.$passwordValidator.invalid) {
          return
        }
        if (self.password.new !== self.password.new2) {
          self.$passwordValidator.new2.valid = false
          self.$passwordValidator.new2.invalid = true
          self.$passwordValidator.new2.notmatch = true
          return
        } else {
          self.$passwordValidator.new2.notmatch = false
        }
        self.$dispatch('submitPassword', self.password)
        self.password = {
          old: '',
          new: '',
          new2: ''
        }
      })
    }
  },
  data: function () {
    return {
      password: {
        old: '',
        new: '',
        new2: ''
      }
    }
  }
}
</script>


<style scoped>
  .profile-label {
    padding: 4px 0;
  }
  .profile-textfield {
    margin-top: -20px;
  }
</style>



// WEBPACK FOOTER //
// EditPasswordForm.vue?cfb49026